<!-- TEXTBOX -->
@if (entry?.base?.display) {
  <form [connect]="'payloadStates.' + entry.formControlAttributes?.connectPath" class="question-class" [formGroup]="form"></form>
  @if (radioForm){
    <form [formGroup]="radioForm" class="radio-form">
      <app-applicable-circumstance-single-page-proxy-form
        [componentDisplayAttributes]="applicableCircumstanceRadioAttributes"
      >
      </app-applicable-circumstance-single-page-proxy-form>
    </form>
  }
  @if(showNextQuestion === "Yes"){
    @if(entry.custom?.selectedYesInfoMessage){
      <span [innerHTML]="entry.custom?.selectedYesInfoMessage"></span>
    }
    @if (eventForm){
      <form [formGroup]="eventForm" class="event-form">
        <app-life-event-single-page-proxy-form
          [componentDisplayAttributes]="lifeEventSelectorAttributes"
        >
        </app-life-event-single-page-proxy-form>
      </form>
    }
    @if (dateForm){
      <form [formGroup]="dateForm" class="date-form" [disabled]="!eventForm.valid">
        <app-date-of-life-event-single-page-proxy-form
          [componentDisplayAttributes]="dateOfLifeEventSelectorAttributes" 
        >
        </app-date-of-life-event-single-page-proxy-form>
      </form>
  
    }
  }@else if(showNextQuestion === "No"){
    @if(entry?.custom?.selectedNoInfoMessage){
      <span [innerHTML]="entry.custom?.selectedNoInfoMessage"></span>
    }
  }

}